import Image from "next/image";

function BrandLogo({ desktopOpen }) {
  return (
    <>
      <div className={`flex items-start justify-center ${desktopOpen ? "pt-6 px-2 pb-1" : "pt-4 pb-3"} bg-[#F8FAFC]`}>
        <Image
          src="/logo/brand_logo.png"
          alt="Brand Logo"
          width={desktopOpen ? 90 : 50}
          height={desktopOpen ? 40 : 30}
          className={`object-contain mt-0  `}
        />
      </div>
    </>


  );
}

export default BrandLogo;
